// Convierte una hora local ("2026-11-13T18:30" en America/Santiago) a un instante ISO con su offset real,
// considerando el cambio de hora. Sin librerías: se calcula el offset de la zona con Intl y se corrige una vez
// (suficiente salvo en la hora que no existe al adelantar el reloj, donde se usa la siguiente válida).

function offsetMinutes(utcMs: number, timeZone: string): number {
  const parts: Record<string, string> = {};
  for (const p of new Intl.DateTimeFormat('en-US', {
    timeZone, hourCycle: 'h23', year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', second: '2-digit',
  }).formatToParts(new Date(utcMs))) parts[p.type] = p.value;
  const asUtc = Date.UTC(+parts.year!, +parts.month! - 1, +parts.day!, +parts.hour!, +parts.minute!, +parts.second!);
  return Math.round((asUtc - utcMs) / 60_000);
}

const LOCAL = /^(\d{4})-(\d{2})-(\d{2})T(\d{2}):(\d{2})$/;

export function localToInstant(local: string, timeZone: string): string {
  const m = LOCAL.exec(local);
  if (!m) throw new Error(`hora local inválida: ${local}`);
  const wall = Date.UTC(+m[1]!, +m[2]! - 1, +m[3]!, +m[4]!, +m[5]!);
  let utc = wall - offsetMinutes(wall, timeZone) * 60_000;
  utc = wall - offsetMinutes(utc, timeZone) * 60_000;
  return new Date(utc).toISOString();
}
